module.exports = __webpack_public_path__ + "media/images/favicon-eead35a5328e86f7d3d97f892011d419.jpeg";